/**
 * @generated SignedSource<<123e8afc89785c2825ae18812f7323cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipAssetUsagesOrderBy = "name" | "watch_progress" | "%future added value";
export type CreateMemberAssetUsagesCSVDataInput = {
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  memberHasWatched?: boolean | null;
  orderBy?: OrganizationMembershipAssetUsagesOrderBy | null;
  organizationMembershipId: string;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportAssetUsagesTableExportCSVButtonMutation$variables = {
  input: CreateMemberAssetUsagesCSVDataInput;
};
export type AdminMembersReportAssetUsagesTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportAssetUsagesTableExportCSVButtonMutation = {
  response: AdminMembersReportAssetUsagesTableExportCSVButtonMutation$data;
  variables: AdminMembersReportAssetUsagesTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberAssetUsagesCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberAssetUsagesCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportAssetUsagesTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportAssetUsagesTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ec16d345a8e52b346b3ca0ae39f532f",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportAssetUsagesTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportAssetUsagesTableExportCSVButtonMutation(\n  $input: CreateMemberAssetUsagesCSVDataInput!\n) {\n  response: createMemberAssetUsagesCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38b57965a09b15aa7d70859d51533e13";

export default node;
